import api from "app/api";

export interface PasswordRecoveryForm {
  password: string;
}

export async function passwordRecovery(item: PasswordRecoveryForm, token: string) {
  return api.post(
    '/identity/password-recovery?token=' + token,
    {
      PasswordRecoveryForm: item,
    },
    {
      public: true,
    }
  );
}